import dayjs from "dayjs";
import { useGlobal } from "@/migrated-widgets/table-map/contexts/GlobalState";
import { useAsync } from "@/migrated-widgets/table-map/hooks/useAsync";
import { MapDataLayerService } from "@/migrated-widgets/table-map/services";
import { Audience, GetAudienceVisitorReportsResponse } from "@/migrated-widgets/table-map/services/MapDataLayer/types/Engage.types";

// * CHUNKS OF 5000 records.
const pageSize =
  Number(process.env.NEXT_PUBLIC_AUDIENCE_VISITORS_PAGE_SIZE) ?? 5000;

export const useAudienceVisitorsTableMapData = () => {
  const { params } = useGlobal();
  async function getAudienceVisitors(
    page = 0,
    results: Record<string, Audience> = {}
  ) {
    const res = await MapDataLayerService.get<GetAudienceVisitorReportsResponse>("/engage", {
        level: "audience",
        segment: "zipcode",
        startDate: dayjs(params.startDate).format("YYYY/MM/DD"),
        endDate: dayjs(params.endDate ?? new Date()).format("YYYY/MM/DD"),
        dealerId: params.dealerRefId,
        token: params.token,
        offset: page * pageSize,
        limit: pageSize,
    });

    const { elementCollection } = res;
    const allElements = elementCollection.flatMap(
      (element) => element.dataCollection
    );
    // // * COMBINE PAGES OF DATA
    for (const element of elementCollection) {
      const key = `${element.audienceId}-${element.audienceMakeId}-${element.audienceModelId}`
      if (!results[key]) {
        results[key] = element;
        continue;
      }
       // * Merge dataCollections
       results[key] = {
        ...results[key],
        dataCollection: [
          ...results[key].dataCollection,
          ...element.dataCollection,
        ],
      };
    }

    if (allElements.length < pageSize) {
      return Object.values(results).flat();
    }
    return getAudienceVisitors(page + 1, results);
  }

  const { response: audiences = [], loading: loadingAudiences = true } =
    useAsync(async () => {
      const audienceVisitors = await getAudienceVisitors();
      return audienceVisitors;
    }, [params]);

  return {
    audiences,
    loadingAudiences,
  };
};
